import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-pause",
  "use": "icon-ib-pause-usage",
  "viewBox": "0 0 13 16",
  "content": "<symbol viewBox=\"0 0 13 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-pause\">\r\n<rect width=\"4\" height=\"16\" rx=\"1\" fill=\"black\" />\r\n<rect x=\"9\" width=\"4\" height=\"16\" rx=\"1\" fill=\"black\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol